import { render, staticRenderFns } from "./ConfigTabTelaExibicao.vue?vue&type=template&id=630a7cfe&scoped=true"
import script from "./ConfigTabTelaExibicao.vue?vue&type=script&lang=js"
export * from "./ConfigTabTelaExibicao.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabTelaExibicao.vue?vue&type=style&index=0&id=630a7cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a7cfe",
  null
  
)

export default component.exports